import primaryButtonActive from '../../../../../common/algorithms/primary-button-active';

const custom = (params) => primaryButtonActive(params, false);

export default custom;
